export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOG_OUT = 'LOG_OUT'